/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Pc_Faq_1_AInputs */

const en_pc_faq_1_a = /** @type {(inputs: Pc_Faq_1_AInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Yes. PhotoCraft is released under the MIT or Apache-2.0 license. There is no subscription, trial or account, and you can use it for commercial work.`)
};

const zh_pc_faq_1_a = /** @type {(inputs: Pc_Faq_1_AInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`是的。PhotoCraft 以 MIT 或 Apache-2.0 许可证发布，没有订阅、没有试用期、不需要账号，也可以用于商业项目。`)
};

/**
* | output |
* | --- |
* | "Yes. PhotoCraft is released under the MIT or Apache-2.0 license. There is no subscription, trial or account, and you can use it for commercial work." |
*
* @param {Pc_Faq_1_AInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const pc_faq_1_a = /** @type {((inputs?: Pc_Faq_1_AInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Pc_Faq_1_AInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_pc_faq_1_a(inputs)
	return zh_pc_faq_1_a(inputs)
});
export { pc_faq_1_a as "pc.faq.1.a" }